// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1BCEQ","backTop":"Footer_backTop__36ETM","icons":"Footer_icons__2Wxx2"};